export default "__VITE_ASSET__MdXm0AF7__"